import React, { useEffect, useState } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';
import RichTextEditorMeta from '../../../rte-meta';
export const MetaDetailsPlugin = () => {
  const [editor] = useLexicalComposerContext();
  const [text, setText] = useState<string>('');
  useEffect(() => {
    editor.getEditorState().read(() => {
      const root = $getRoot();
      setText(root.getTextContent());
    }); // for initial read

    const removeTextContentListener = editor.registerTextContentListener(textContent => {
      setText(textContent);
    }); // for updates

    return removeTextContentListener; // cleanup
  }, [editor]);
  return <RichTextEditorMeta text={text} />;
};